import PropTypes from 'prop-types';
import { sortBy } from 'lodash';
import clsx from 'clsx';

import { DIETARY_TAG_MAP } from '../../../constants/constants';
import PdpPeriodicity from '../../../../../../components/product/PdpPeriodicity/PdpPeriodicity';
import { trackPdpOsnReview } from '../../../../../../components/product/PdpPeriodicity/segment';
import { usePostSetPeriodicity } from '@hungryroot/periodicities';
import { useTagGroup, tagGroups } from '@hungryroot/tags';

import styles from './Header.module.css';

/*
This is the reusable header for all product cards
props:
product: product data returned from get product endpoint or passed down by parents
*/

const Header = ({
  product,
  isCustomizationPage,
  onPeriodicityChange,
  headerClass,
}) => {
  const {
    location: { pathname },
  } = window;

  const { data: spicyTags } = useTagGroup(tagGroups.spiceLevel);
  const usePostSetPeriodicityMutation = usePostSetPeriodicity();
  return (
    <div className={`header hr-mb-24 ${headerClass}`}>
      <div className="dishtype-and-infos">
        <h2 className="hr-subtitle-md brand-name hr-mb-4">
          {product.brand_name}
        </h2>
        <h1 className={clsx('hr-title-md', styles['weight-heavy'])}>
          {product.name}
        </h1>

        <div className="hr-subtitle-md pills-container">
          {product.dietary_tags.map((tag) => {
            if (isCustomizationPage) {
              return (
                <span className="filter-pill non-interactive" key={tag}>
                  {tag}
                </span>
              );
            } else {
              return (
                <a
                  className="filter-pill anchor-black"
                  href={`/foods/?${DIETARY_TAG_MAP[tag]}=1`}
                  key={tag}
                >
                  {tag}
                </a>
              );
            }
          })}
        </div>
        <div>
          {product && product.spicy_level !== undefined && spicyTags ? (
            <div className="spicy-data">
              <img
                className="spicy-icon"
                src={`/public/img/modals/pepper.svg`}
                alt="Pepper icon"
              />
              <span className="hr-paragraph">
                {sortBy(spicyTags.tags, ['id'])[product.spicy_level]?.name}
              </span>
            </div>
          ) : null}
        </div>
        {product.periodicity !== undefined && pathname !== '/limited-time/' && (
          <PdpPeriodicity
            value={product.periodicity}
            productId={product.id}
            testid={'product-card'}
            onPeriodicityChange={(value) => {
              usePostSetPeriodicityMutation.mutate({
                data: { product_id: product.id, periodicity: value },
              });
              onPeriodicityChange(value);
              trackPdpOsnReview({
                productId: product.id,
                path: window.location.pathname,
                rating: value,
              });
            }}
          />
        )}
      </div>
    </div>
  );
};

Header.propTypes = {
  product: PropTypes.object.isRequired,
};

export default Header;
